module.exports = __webpack_public_path__ + "static/service-writing-2da13315f61b20020c0a2e3202ab8c3f.jpg";